import type {PressReleasePreview} from '@openapi/press-release';
import {previewPressReleaseApi} from '../client';

export const getPressReleaseForPreview = async (
  {
    releaseId,
    companyId,
  }: {
    releaseId: number;
    companyId: number;
  },
  init?: RequestInit,
): Promise<PressReleasePreview> => {
  const response = await previewPressReleaseApi.getPressReleasePreview(
    {releaseId, companyId},
    init,
  );
  return response.data;
};
